import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Stat from '../../../components/shared/Stat';
import LineChart from '../../../components/shared/LineChart';
import * as actions from '../../../redux/actions';
import { getTokenMintedCharts } from '../../../redux/reducers';
import { formatTimestamp } from '../../../utils';
import LoadingIndicator from "../../../components/containers/LoadingIndicator";

class TokenMintedChart extends Component {
	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.period !== prevProps.period) {
			this.fetchData();
		}
	}

	fetchData() {
		const { fetchTokenMinted, period } = this.props;
		fetchTokenMinted({period});
	}
	render() {
		const { volume: { totalSum, /* totalCount,*/ pctChange, data }, period } = this.props;
		const formatter = (date) => formatTimestamp(date, period);
		const valueFormatter = (value, name, props) => [new Intl.NumberFormat('en').format(value) + ' txns'];
		if (!this.props.volume.loading) {
			return (
				data && data.length ?
					<Fragment>
						<Stat count={totalSum} pct={pctChange} label="txns" />
						<br />
						<LineChart
							graphType={this.props.graphType}
							data={data}
							tickFormatter={formatter}
							labelFormatter={formatter}
							valueFormatter={valueFormatter}
						/>
					</Fragment>
				:  <div>No Tokens available for the selected period</div>
			);
		} else {
			return <LoadingIndicator />
		}
	}
}

const mapStateToProps = (state) => ({
	volume: getTokenMintedCharts(state)
});

TokenMintedChart = connect(mapStateToProps, actions)(TokenMintedChart);

export default TokenMintedChart;
